import { computed, ref, watch } from 'vue';

import type { Cart, CartState, Provider } from '../components/cart/cart.type';

const carts = ref<Array<Cart>>([]);
const itemsList = ref<CartState>({});
export default function useCartWidget() {
  const sessionsStorageKey = 'youbook_cart_count';
  const sessionsStorageTTL = 1000 * 60 * 15; // 15 minutes

  const isEmptyCart = computed(() => carts.value.length < 1);

  const itemsCount = computed(() => {
    let itemsCount = 0;
    const products = { ...itemsList.value };
    delete products.ttl;
    const values = Object.values(products);
    if (values.length) {
      values.forEach(value => itemsCount += value ?? 0);
    }
    return itemsCount;
  });

  function handleCartEvent(event: any) {
    if (event.data?.type === 'widget-resize' || event.data?.key === '__VUE_DEVTOOLS_VUE_DETECTED_EVENT__' || !event.data || !event)
      return;
    const data = typeof event.data == 'string' ? JSON.parse(event.data) : event.data;
    if (data.event_id !== 'cart_update')
      return;
    const providerKey: Provider = data.provider;
    itemsList.value[providerKey] = Number.parseInt(data.items_count);
    saveProductsToLocalStorage();
  }

  function saveProductsToLocalStorage() {
    const now = new Date();
    itemsList.value.ttl = now.getTime() + sessionsStorageTTL;
    window.localStorage.removeItem(sessionsStorageKey);
    window.localStorage.setItem(sessionsStorageKey, JSON.stringify(itemsList.value));
  }

  function loadProductsFromLocalStorage() {
    const productsFromStorage = window.localStorage.getItem(sessionsStorageKey);
    if (!productsFromStorage)
      return;
    const now = new Date();
    const products = JSON.parse(productsFromStorage);
    if (now.getTime() > products.ttl) {
      window.localStorage.removeItem(sessionsStorageKey);
      return;
    }
    itemsList.value = products;
  }

  watch(() => itemsList, () => {
    if (Object.keys(itemsList.value).length) {
      const test = { ...itemsList.value };
      delete test.ttl;
      carts.value = Object.entries(test)
        .filter(([provider]) => provider === 'youbook') // Antoine - 25/09/2026 - On ne construit que le panier Youbook
        .map(([provider, count]) => ({ id: provider, provider, count: Number.parseInt(count.toString()) }) as Cart);
    }
  }, { deep: true });

  return {
    carts,
    isEmptyCart,
    itemsList,
    itemsCount,
    handleCartEvent,
    loadProductsFromLocalStorage,
  };
}
